import { useCompanyCanonicalUrl } from '@/hooks/useCompany';
import { getRegisterModalVariant } from './useRegisterModalVariantDetect';

//This hook here is for creating control/variant groups for
//the experiment of loading full reports before showing rego modal
export function useLoadFullReportDetect(): boolean {
  const canonicalUrl = useCompanyCanonicalUrl();
  const variant = getRegisterModalVariant(canonicalUrl);
  return variant === 'earlierFullReport';
}
